<template>
    <div class="list-dropdown no-spaces self-close button-selection">
        <input type="checkbox" id="filterSort" class="list-dropdown__trigger">
        <div class="list-dropdown__wrapper">
            <label class="list-dropdown__title" for="filterSort">
                <span class="title">{{selected.title}}</span>
            </label>
            <div class="list-dropdown__container">
                <div class="list-dropdown__content">
                    <div class="list-dropdown__scroll">
                        <ul class="list-dropdown__select-list bigger">
                            <li v-for="item in sortOrders">
                                <button type="button" :class="{'selected' : item.title==selected.title}" @click="selectOrder(item)">{{item.title}}</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="list-dropdown__bg"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                default() {
                    return { title: "По-умолчанию", property: 'price', type: 'asc' }
                }
            }
        },
        data() {
            return {
                sortOrders: [
                    { title: "По-умолчанию", property: 'price', type: 'asc' },
                    { title: "По алфавиту", property: 'title', type: 'asc' },
                    { title: "По цене (по возрастанию)", property: 'price', type: 'asc' },
                    { title: "По цене (по убыванию)", property: 'price', type: 'desc' },
                ],
                selected: this.value
            }
        },
        methods: {
            selectOrder(sortOrder) {
                this.$set(this.selected, "title", sortOrder.title);
                this.$set(this.selected, "property", sortOrder.property);
                this.$set(this.selected, "type", sortOrder.type);   
            }
        },
        watch: {
            selected: {
                deep: true,
                handler(to) {
                    this.$emit('input', this.selected);
                }               
            }
        },
        created() {
            if (!Object.values(this.value).length) {
                this.$set(this.selected, "title", 'По-умолчанию');
                this.$set(this.selected, "property", 'price');
                this.$set(this.selected, "type", 'asc');
            }
        }
    }
</script>